import Breadcrumb from '../components/Breadcrumb';
import { useParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import ViewProdutosLayer from '../components/ViewProdutosLayer';

function Edit({ id }) {
    const { data, mutate } = useFetch(`produto/${id}`);
    return <ViewProdutosLayer data={data} mutate={mutate} backTo="/produtos" />;
}

function Layer() {
    const { id } = useParams();

    if (id) return <Edit id={id} />;

    return <ViewProdutosLayer backTo="/produtos" />;
}

const ProdutosPage = () => {
    const { id } = useParams();

    return (
        <>
            <Breadcrumb
                title={!Boolean(id) ? 'Cadastrar - Produto' : 'Editar - Produto'}
                icon={!Boolean(id) ? 'solar:bag-4-outline' : 'solar:box-outline'}
            />
            <Layer />
        </>
    );
};

export default ProdutosPage;
